// grading type constants
export const TOPK = 'selectTopKGradingType';
export const ALL = 'selectAllGradingType';
// passing policy constants
export const AGGREGATE = 'aggregateGradeAboveThreshold';
export const ALL_PASS = 'allItemsPassed';

export type TopK = 'selectTopKGradingType';
export type All = 'selectAllGradingType';
export type Aggregate = 'aggregateGradeAboveThreshold';
export type AllPass = 'allItemsPassed';

export default {
  TOPK,
  ALL,
  AGGREGATE,
  ALL_PASS,
};
